import React from 'react';
import PropTypes from 'prop-types';

const ResultsView = props => (
  <React.Fragment>
    <div className={'col-sm-7 col-sm-offset-1 startup-calculator-results-labels-left'}>
      <div className="startup-calculator-results">
        <label htmlFor="expenseSum">Total Expenses</label>
        <label htmlFor="assetSum">Total Assets</label>
        <label htmlFor="costSum">Total Recurring Costs</label>
      </div>
    </div>
    <div className="col-sm-3 startup-calculator-results-labels-right">
      <div className="startup-calculator-results">
        <label htmlFor="total">Total</label>
      </div>
    </div>
    <div className={'col-sm-7 col-sm-offset-1 startup-calculator-results-col-left'}>
      <div className="startup-calculator-results">
        <ResultsViewOutput
          sum={props.expenseSum}
          id="expenseSum"
        />
        <ResultsViewOutput
          sum={props.assetSum}
          id="assetSum"
        />
        <ResultsViewOutput
          sum={props.costSum}
          id="costSum"
        />
      </div>
    </div>
    <div className="col-sm-3 startup-calculator-results-col-right">
      <div className="startup-calculator-results">
        <ResultsViewOutput
          sum={props.total}
          id="total"
        />
      </div>
    </div>
  </React.Fragment>
);

const ResultsViewOutput = props => (
  <div className="startup-calculator-input">
    <input
      type="text"
      value={props.sum}
      id={props.id}
      disabled
    />
  </div>
);

ResultsViewOutput.propTypes = {
  id: PropTypes.string.isRequired,
  sum: PropTypes.string.isRequired,
};

ResultsView.propTypes = {
  expenseSum: PropTypes.string.isRequired,
  assetSum: PropTypes.string.isRequired,
  costSum: PropTypes.string.isRequired,
  total: PropTypes.string.isRequired,
};

export default ResultsView;



// WEBPACK FOOTER //
// ./src-react/StartupCalculator/components/ResultsView.jsx